export enum ConversationalSearchStorageManagerValues {//eslint-disable-line @stencil-community/ban-exported-const-enums
  // In order to load new session storage key-value, please, register key below for better state management
  CHAT_VISIBILITY = 'conversational_search_chat_visibility',
  UID = 'conversational_search_uid',
  CHAT_ACTION = 'conversational_search_chat_action',
  TERMS_AND_CONDITIONS = 'conversational_terms_and_conditions',
}

export class ConversationalSearchStorageManager {
  private static instance: ConversationalSearchStorageManager;
  sessionStorage: Storage;

  private constructor() {
      this.sessionStorage = window.sessionStorage;
  }

  public static getInstance(): ConversationalSearchStorageManager {
      if (!ConversationalSearchStorageManager.instance) {
        ConversationalSearchStorageManager.instance = new ConversationalSearchStorageManager();
      }

      return ConversationalSearchStorageManager.instance;
  }

  private setValue(managerAction: ConversationalSearchStorageManagerValues, value?: string) {
      if (managerAction === ConversationalSearchStorageManagerValues.UID)
        return value;

      return 'true';
  }

  public actionSetter(managerAction: ConversationalSearchStorageManagerValues, value?: string) {
      this.sessionStorage.setItem(managerAction, this.setValue(managerAction, value));
  }

  public actionGetter(managerAction: ConversationalSearchStorageManagerValues) {
      return this.sessionStorage.getItem(managerAction);
  }

  public actionRemover(managerAction: ConversationalSearchStorageManagerValues) {
      this.sessionStorage.removeItem(managerAction);
  }
}